import { Component } from '@theme/component';

/** Indéscents — les barres se remplissent quand le graphique entre dans l'écran. */
class IndescentsRepartition extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (!('IntersectionObserver' in window)) { this.classList.add('is-in'); return; }
    this.io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      this.classList.add('is-in');
      this.io?.disconnect();
      this.io = null;
    }, { threshold: 0.25 });
    this.io.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    this.io?.disconnect();
    this.io = null;
  }
}

if (!customElements.get('indescents-repartition')) customElements.define('indescents-repartition', IndescentsRepartition);
